import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ota-update-modal',
  templateUrl: './ota-update-modal.component.html',
  styleUrls: ['./ota-update-modal.component.scss'],
  standalone: false,
})
export class OtaUpdateModalComponent {
  constructor(
    public dialogRef: MatDialogRef<OtaUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OtaUpdateModalData,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onUpdate(): void {
    this.dialogRef.close(true);
  }
}

export interface OtaUpdateModalData {
  displayName?: string;
}
